import { useEffect, useState } from "react";
import { useTheme } from "styled-components";
import { observer, inject } from "mobx-react";
import { useNavigate, useLocation } from "react-router-dom";
import { Text } from "../UI";
import { CircleDiv } from "../components/Common";
import menuImg from "../assets/img/menu.svg";
import alertImg from "../assets/img/alert_mobile.svg";
import arrowImg from "../assets/img/arrow-right-nav.svg";
import { useTranslation } from "react-i18next";
import { publish } from "../utils/events";
import removeImg from "../assets/img/close-circle.svg";
import badgeImg from "../assets/img/badge_circle.svg";


const showDrawer = () => {
  publish("showDrawer");
};

const MobileHeader = ({
  userStore,
  tenantsStore,
  repairPagesStore,
  navigateTo,
  step,
}) => {
  const [title, setTitle] = useState("");
  const theme = useTheme();
  const location = useLocation();
  const navigate = useNavigate();

  const { t, i18n } = useTranslation("menu");
  const isRtl = i18n.dir() === "rtl";



  const [newMessages, setNewMessages] = useState([])

  useEffect(() => {
    const allNewRepairMessages = repairPagesStore.allRepairMessages?.filter((msg) => msg.ISTENANT !== "Y" && msg.ISNEW === "Y")?.map(msg => ({ ...msg, REPAIRMSG: true })) || [];
    const allNewMessages = tenantsStore.allMessages?.filter((msg) => msg.WASREADFLAG !== "Y") || [];
    setNewMessages([...allNewRepairMessages, ...allNewMessages]);
  }, [repairPagesStore.allRepairMessages, tenantsStore.allMessages])


  useEffect(() => {
    const fetchData = async () => {


      const data = {
        CUST: userStore.userDetails.CUST,
        DNAME: tenantsStore.selectedSiteSpace?.DNAME,
        ENV: tenantsStore.selectedSiteSpace?.DNAME,
        SPACENAME: tenantsStore.selectedSiteSpace?.SPACENAME
      }


      const repairs = await repairPagesStore.getConversationMessages(data)

      const repairsMessages = repairs?.map(rep => (rep.ZCOB_TENANTCONV_SUBFORM?.map(msg => ({
        ...msg, REPAIRNAME: rep.REPAIRNAME
      })) || [])).flat() || [];

      const newMessages = repairsMessages?.filter((msg) => msg.ISNEW === "Y" && msg.ISTENANT !== "Y")
        ?.map(msg => ({ ...msg, REPAIRMSG: true })) || [];

      const project = tenantsStore.sites?.find(
        (s) => s.SITENUM === tenantsStore.selectedSiteSpace?.SITENUM && s.DNAME === tenantsStore.selectedSiteSpace?.DNAME
      );


      let messages = []
      if (tenantsStore.selectedSiteSpace?.CONTSALE === "Y" &&
        tenantsStore.selectedSiteSpace?.ISONLYBEDEK !== "Y" &&
        project?.BEDEK !== "Y") {

        const bodyData = {
          MAINCUST: userStore.userDetails.MAINCUST,
          CUST: userStore.userDetails.CUST,
          MAINENV: userStore.userDetails.MAINENV,
          CUSTNAME: userStore.userDetails?.CUSTNAME,
          SITEID: tenantsStore.selectedContract?.SITEID,
          BUILDINGNUM: tenantsStore.selectedContract?.BUILDINGNUM,
          CONTNAME: tenantsStore.selectedContract?.CONTNAME,
          DNAME:
            tenantsStore.selectedContract?.DNAME ||
            tenantsStore.selectedSiteSpace?.DNAME,
        };
        messages = await tenantsStore.getSaleContractMessages(bodyData);

      }
      const newContractMessages = messages?.filter((msg) => msg.WASREADFLAG !== "Y") || [];

      const allMessages = [...newMessages, ...newContractMessages]

      setNewMessages(allMessages);




    };

    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tenantsStore.selectedSiteSpace]);


  useEffect(() => {
    i18n.changeLanguage(userStore.language);
  }, [userStore.language]);

  useEffect(() => {
    if (location.pathname.includes("/applies")) {
      setTitle("applies");
    } else if (location.pathname === "/tenant/messages") {
      setTitle("messages");
    } else if (
      location.pathname === "/tenant/messages" ||
      location.pathname === "/bedek/new-repair-page" ||
      location.pathname === "/tenant/new-repair-page"
    ) {
      setTitle("apply_repair");
    } else if (location.pathname === "/tenant/contacts") {
      setTitle("contacts");
    } else if (location.pathname === "/tenant/docs") {
      setTitle("docs");
    } else {
      if (!!navigateTo) {
        setTitle(navigateTo);
      } else {
        setTitle("lobby");
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location]);

  return (
    <div
      style={{
        display: "flex",
        flexDercrion: "row",
        justifyContent: "space-between",
        backgroundColor: theme.color.primary,
        padding: 15,
      }}
    >
      <div
        style={{
          width: "100%",
          display: "flex",
          flexDercrion: "row",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <div
          style={{
            display: "flex",
            flexDercrion: "row",
            alignItems: "center",
            gap: 10,
          }}
        >
          {!!navigateTo ? (
            <img
              src={arrowImg}
              alt="navigate"
              style={{ height: 24, width: 24, transform: !isRtl && "rotate(180deg)" }}
              onClick={() => {
                if (tenantsStore.selectedSiteSpace?.ISONLYBEDEK === "Y") {
                  location.pathname === "/bedek/mobile-new-defect"
                    ? navigate("/bedek/new-repair-page")
                    : navigate("/bedek/applies");
                } else {
                  location.pathname === "/bedek/mobile-new-defect"
                    ? navigate("/tenant/new-repair-page")
                    : navigate("/tenant/applies");
                }
              }}
            />
          ) : !!step ? (
            <div
              title="close"
              style={{
                mask: `url(${removeImg}) no-repeat center / contain`,
                backgroundColor: theme.color.white,
                width: 24,
                height: 24,
              }}
              onClick={() => {
                if (!!step) {
                  if (location.pathname.includes("/tenant")) {
                    navigate("/tenant/new-repair-page", { state: { step: 1 } });
                  } else {
                    navigate("/bedek/new-repair-page", { state: { step: 1 } });
                  }
                } else {
                  navigate(-1);
                }
              }}
            ></div>
          ) : (
            <img
              src={menuImg}
              alt="navigate"
              style={{ height: 24, width: 24 }}
              onClick={showDrawer}
            />


          )}
          {!step && (
            <Text.H4 color={theme.color.white} style={{ textAlign: "start" }}>
              {t(`${title}`)}
            </Text.H4>
          )}
        </div>
        {!step && (
          <div style={{ display: "flex", flexDirection: "row", gap: 10 }}>
            {newMessages.length > 0 && <div
              style={{
                position: "relative",
                mask: `url(${badgeImg}) no-repeat center / contain`,
                backgroundColor: "#2DC8A8",
                border: `1px solid ${theme.color.white}`,
                borderRadius: 50,
                width: 10,
                height: 10,
                top: 0,
                left: isRtl ? -20 : +20,
                zIndex: 99
              }}>
            </div>}
            <img
              src={alertImg}
              alt="repair_messages"
              style={{ height: 20, width: 20, cursor: "pointer", marginTop: 5 }}
              onClick={() => repairPagesStore.allRepairMessages?.length > 0 ?
                navigate("/tenant/repair_messages_list") : null}

            />
            <CircleDiv
              backgroundColor={theme.color.primary}
              height={30}
              width={30}
              style={{ border: `1px solid ${theme.color.white}` }}
            >
              <Text.BB color={theme.color.white} style={{ textAlign: "center" }}>
                {userStore.userDetails?.NAME?.split(" ")
                  .map((n) => n.slice(0, 1))
                  .join("")}
              </Text.BB>
            </CircleDiv>

          </div>
        )}
      </div>

    </div >
  );
};
export default inject("userStore", "tenantsStore", "repairPagesStore")(observer(MobileHeader));
